<template>
  <div>
    <banner-top :text="titletext"></banner-top>
    <div class="bg"></div>
    <div class="success">
        <div>
            <img src="../assets/icon32.png" alt="">
        </div>
        <div style="font-size: 18px; margin-bottom: 0.8rem;">报名成功</div>
        <div style="margin-bottom: 2rem">您可以在【我的订单】中查看</div>
    </div>
    <div class="nav">
        <button @click="toRegistration()">查看报名信息</button>
        <button><router-link :to="{name:'order'}">我的订单</router-link></button>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'

export default {
  name: 'succeed',
  components: { bannerTop },
  data () {
    return {
      checked: false,
      titletext: '报名成功'
    }
  },
  methods: {
    toRegistration () {
      this.$router.push({name: 'registration', query: {order_no: this.$route.query.order_no}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.success {
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    color: #333;
    background: #fff;
}
.success img {
    width: 6.5rem;
    margin: 2rem 2rem 0.5rem 2rem;
}
.success div {
    margin-bottom: 0.5rem;
}
.nav {
  width: 100%;
  height: 3rem;
  display: flex;
  margin-top: 1.5rem;
  justify-content: space-around;
}
.nav button {
    width: 40%;
    height: 2.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/order/succeed.vue